module.exports = __webpack_public_path__ + "fonts/FuturaPT-BoldObl.eb09ecce.woff2";